var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardsContainer, PerkCardContainer, PerkCardDescription, PerkCardTitle, PerkIconContainer, PerksContainer, PerksContainerTitle } from './subcomponents';
import Carousel from '../../../../../ui/molecules/Carousel';
import { colors } from '../../../../../ui/theme';
var Perks = function (_a) {
    var clientId = _a.clientId, perks = _a.perks;
    var t = useTranslation().t;
    var isLessThanDesktop = useWindowSize().isLessThanDesktop;
    var perksCards = perks.map(function (_a) {
        var icon = _a.icon, titleTranslationKey = _a.titleTranslationKey, descriptionTranslationKey = _a.descriptionTranslationKey;
        var dataCyKey = t("".concat(clientId, ".perks.").concat(descriptionTranslationKey));
        return (_jsxs(PerkCardContainer, __assign({ "data-cy": "perk-card-".concat(dataCyKey) }, { children: [_jsx(PerkIconContainer, { children: _jsx(FontAwesomeIcon, { "aria-hidden": "false", icon: icon, size: "2x", color: colors.white }) }), _jsx(PerkCardTitle, { children: t("".concat(clientId, ".perks.").concat(titleTranslationKey)) }), _jsx(PerkCardDescription, { children: t("".concat(clientId, ".perks.").concat(descriptionTranslationKey)) })] }), titleTranslationKey));
    });
    return (_jsxs(PerksContainer, { children: [_jsx(PerksContainerTitle, __assign({ "data-cy": "perks-header" }, { children: t("".concat(clientId, ".perks.perksHeader")) })), _jsx(CardsContainer, { children: isLessThanDesktop ? (_jsx(Carousel, __assign({ dataCy: "perk-carousel", itemsToShow: perks.length }, { children: perksCards }))) : (perksCards) })] }));
};
export default Perks;
